import { gql } from 'apollo-angular';

const GET_RFP_PUBLISH_DETAIL = gql`
  query getRfpPublishDetail($rfpId: Long!) {
    rfpPublishedDetail(rfpId: $rfpId) {
      auditInfo {
        createdBy
        createdDate
        lastModifiedBy
        lastModifiedDate
      }
      contactInfo {
        name
        email
        phone
      }
      description
      requirements
      rfpId
      rfpProjectedDate
      rfpPublishedDate
    }
  }
`;

export default GET_RFP_PUBLISH_DETAIL;
